import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: 'AIzaSyCHlFzdPP_mzAd2_XunrBtR7pOihq3uUSo',
  authDomain: 'eb-games-website.firebaseapp.com',
  projectId: 'eb-games-website',
  storageBucket: 'eb-games-website.firebasestorage.app',
  messagingSenderId: '222765005801',
  appId: '1:222765005801:web:6d3535577b49c51056a978',
  measurementId: 'G-4JENPPVCWF'
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const googleProvider = new GoogleAuthProvider();

googleProvider.setCustomParameters({
  prompt: 'select_account'
});

export { auth, db, googleProvider };